
// import React, { useState, useEffect } from "react";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import { useNavigate } from "react-router-dom";

// // Styles for both components
// const styles = {
//     modalOverlay: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.6)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         zIndex: 9999,
//         padding: '20px',
//         backdropFilter: 'blur(5px)',
//     },
//     modalContainer: {
//         backgroundColor: 'white',
//         borderRadius: '15px',
//         width: '100%',
//         maxWidth: '1400px',
//         maxHeight: '90vh',
//         overflow: 'hidden',
//         boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
//         animation: 'slideIn 0.3s ease-out',
//     },
//     modalHeader: {
//         backgroundColor: '#667eea',
//         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//         color: 'white',
//         padding: '20px 30px',
//         borderBottom: 'none',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     modalBody: {
//         padding: '30px',
//         overflowY: 'auto',
//         maxHeight: 'calc(90vh - 150px)',
//     },
//     modalFooter: {
//         padding: '15px 30px',
//         borderTop: '1px solid #dee2e6',
//         backgroundColor: '#f8f9fa',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         flexWrap: 'wrap',
//         gap: '10px',
//     },
// };

// const PropertiesApproval = () => {
//     const { user, loading } = useAuth();
//     const navigate = useNavigate();
    
//     // State for properties
//     const [properties, setProperties] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [isSearching, setIsSearching] = useState(false);
//     const [approvingId, setApprovingId] = useState(null);
    
//     // Property details modal
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedPropertyDetails, setSelectedPropertyDetails] = useState(null);
    
//     // Pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const [resultsPerPage] = useState(12);

//     const currencyOptions = [
//         { code: "INR", symbol: "₹", name: "Indian Rupee" },
//         { code: "USD", symbol: "$", name: "US Dollar" },
//         { code: "EUR", symbol: "€", name: "Euro" },
//         { code: "GBP", symbol: "£", name: "British Pound" },
//         { code: "AED", symbol: "AED", name: "UAE Dirham" },
//         { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
//         { code: "AUD", symbol: "A$", name: "Australian Dollar" },
//         { code: "CAD", symbol: "C$", name: "Canadian Dollar" }
//     ];

//     // Fetch properties on component mount
//     useEffect(() => {
//         if (user && !loading) {
//             fetchProperties();
//         }
//     }, [user, loading]);

//     // API call to get all Draft properties
//     const fetchProperties = async () => {
//         setIsLoading(true);
//         setError(null);
        
//         try {
//             const response = await apiService.getAll(
//                 `${config.GETAllCOMPANYHOTELS}`
//             );
            
//             const fetchedProperties = response.hotels || response.data || [];
//             setProperties(fetchedProperties);
//             setCurrentPage(1);
//         } catch (error) {
//             console.error("Error fetching properties:", error);
//             setError("Failed to load properties. Please try again.");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Handle search
//     const handleSearch = async () => {
//         if (!searchTerm.trim()) {
//             await fetchProperties();
//             return;
//         }
        
//         setIsSearching(true);
//         setError(null);
        
//         try {
//             const response = await apiService.getAll(
//                 `${config.GETAllCOMPANYHOTELS}?search=${encodeURIComponent(searchTerm)}`
//             );
            
//             const fetchedProperties = response.hotels || response.data || [];
//             setProperties(fetchedProperties);
//             setCurrentPage(1);
//         } catch (error) {
//             console.error("Error searching properties:", error);
//             setError("Failed to search properties. Please try again.");
//         } finally {
//             setIsSearching(false);
//         }
//     };

//     const handleSearchKeyPress = (e) => {
//         if (e.key === 'Enter') {
//             handleSearch();
//         }
//     };

//     // Approve property - Update status from Draft to Published
//     const handleApproveProperty = async (hotelId, companyId, e) => {
//         if (e) e.stopPropagation();
        
//         if (!hotelId || !companyId) {
//             alert("Missing required information to approve this property.");
//             return;
//         }

//         if (!window.confirm("Are you sure you want to approve this property? It will be published and visible to all users.")) {
//             return;
//         }

//         setApprovingId(hotelId);

//         try {
//             const requestData = {
//                 CompanyId: companyId,
//                 HotelId: hotelId,
//                 IsActive: "Published"
//             };

//             const response = await apiService.put(
//                 `${config.UPDATECOMPANYHOTELSTATUS}`,
//                 requestData
//             );

//             if (response.success || response.data) {
//                 alert("Property approved and published successfully!");
                
//                 // Remove the approved property from the list
//                 setProperties(prev => prev.filter(p => p.hotelId !== hotelId && p.companyHotelId !== hotelId));
                
//                 // If details modal is open, close it
//                 if (showDetailsModal && selectedPropertyDetails) {
//                     const isCurrentProperty = 
//                         selectedPropertyDetails.hotelId === hotelId || 
//                         selectedPropertyDetails.companyHotelId === hotelId;
//                     if (isCurrentProperty) {
//                         closeDetailsModal();
//                     }
//                 }
//             } else {
//                 throw new Error(response.message || "Failed to approve property");
//             }
//         } catch (error) {
//             console.error("Error approving property:", error);
//             alert(error.message || "Failed to approve property. Please try again.");
//         } finally {
//             setApprovingId(null);
//         }
//     };

//     // Get lowest room price for a property
//     const getLowestRoomPrice = (roomDetails) => {
//         if (!roomDetails || roomDetails.length === 0) {
//             return null;
//         }
        
//         const validRooms = roomDetails.filter(room => room.price && !isNaN(room.price));
//         if (validRooms.length === 0) return null;
        
//         const lowest = validRooms.reduce((min, room) => 
//             room.price < min.price ? room : min
//         , validRooms[0]);
        
//         return {
//             price: lowest.price,
//             currency: lowest.currency,
//             roomType: lowest.roomType
//         };
//     };

//     // Get validity dates with better formatting
//     const getValidityDates = (roomDetails) => {
//         if (!roomDetails || roomDetails.length === 0) return null;
        
//         let validFrom = null;
//         let validTo = null;
        
//         roomDetails.forEach(room => {
//             if (room.validFrom && room.validFrom !== 'Not specified') {
//                 const fromDate = new Date(room.validFrom);
//                 if (!validFrom || fromDate < validFrom) validFrom = fromDate;
//             }
//             if (room.validTo && room.validTo !== 'Not specified') {
//                 const toDate = new Date(room.validTo);
//                 if (!validTo || toDate > validTo) validTo = toDate;
//             }
//         });
        
//         return {
//             from: validFrom ? formatDate(validFrom) : null,
//             to: validTo ? formatDate(validTo) : null,
//             isActive: validFrom && validTo ? new Date() >= validFrom && new Date() <= validTo : false
//         };
//     };

//     // Open property details modal
//     const openDetailsModal = (property) => {
//         setSelectedPropertyDetails(property);
//         setShowDetailsModal(true);
//     };

//     // Close property details modal
//     const closeDetailsModal = () => {
//         setShowDetailsModal(false);
//         setSelectedPropertyDetails(null);
//     };

//     // Render star rating
//     const renderStars = (rating) => {
//         const stars = [];
//         const fullStars = Math.floor(rating || 0);
//         const hasHalfStar = (rating || 0) % 1 >= 0.5;

//         for (let i = 1; i <= 5; i++) {
//             if (i <= fullStars) {
//                 stars.push(<i key={i} className="ri-star-fill text-warning"></i>);
//             } else if (i === fullStars + 1 && hasHalfStar) {
//                 stars.push(<i key={i} className="ri-star-half-fill text-warning"></i>);
//             } else {
//                 stars.push(<i key={i} className="ri-star-line text-warning"></i>);
//             }
//         }
//         return <span className="d-inline-flex align-items-center">{stars}</span>;
//     };

//     // Format currency
//     const formatCurrency = (amount, currency) => {
//         const symbols = {
//             'INR': '₹',
//             'USD': '$',
//             'EUR': '€',
//             'GBP': '£',
//             'AED': 'AED ',
//             'SGD': 'S$',
//             'AUD': 'A$',
//             'CAD': 'C$'
//         };
//         const symbol = symbols[currency] || currency;
//         return `${symbol}${amount}`;
//     };

//     const getCurrencySymbol = (currencyCode) => {
//         const currency = currencyOptions.find(c => c.code === currencyCode);
//         return currency ? currency.symbol : currencyCode;
//     };

//     // Get meal plan label
//     const getMealPlanLabel = (mealPlan) => {
//         const plans = {
//             'CP': 'CP → Breakfast only',
//             'MAP': 'MAP → Breakfast + Lunch or Dinner',
//             'AP': 'AP → Breakfast + Lunch + Dinner',
//             'EP': 'EP → Room only',
//             'CPAI': 'CPAI → Stay + Breakfast',
//             'MAPAI': 'MAPAI → Stay + Breakfast + Lunch/Dinner',
//             'APAI': 'APAI → Stay + Breakfast + Lunch + Dinner'
//         };
//         return plans[mealPlan] || mealPlan;
//     };

//     // Format date to display
//     const formatDate = (dateString) => {
//         if (!dateString || dateString === 'Not specified') return 'N/A';
        
//         try {
//             const date = new Date(dateString);
//             return date.toLocaleDateString('en-US', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch (error) {
//             return dateString;
//         }
//     };

//     // Get validity period for room details
//     const getValidityPeriod = (roomDetails) => {
//         if (!roomDetails || roomDetails.length === 0) return 'N/A';
        
//         let earliestDate = null;
//         let latestDate = null;
        
//         roomDetails.forEach(room => {
//             if (room.validFrom && room.validFrom !== 'Not specified') {
//                 const fromDate = new Date(room.validFrom);
//                 if (!earliestDate || fromDate < earliestDate) {
//                     earliestDate = fromDate;
//                 }
//             }
            
//             if (room.validTo && room.validTo !== 'Not specified') {
//                 const toDate = new Date(room.validTo);
//                 if (!latestDate || toDate > latestDate) {
//                     latestDate = toDate;
//                 }
//             }
//         });
        
//         if (earliestDate && latestDate) {
//             return `${formatDate(earliestDate)} to ${formatDate(latestDate)}`;
//         } else if (earliestDate) {
//             return `From ${formatDate(earliestDate)}`;
//         } else if (latestDate) {
//             return `Until ${formatDate(latestDate)}`;
//         }
        
//         return 'N/A';
//     };

//     // Pagination
//     const indexOfLastResult = currentPage * resultsPerPage;
//     const indexOfFirstResult = indexOfLastResult - resultsPerPage;
//     const currentResults = properties.slice(indexOfFirstResult, indexOfLastResult);
//     const totalPages = Math.ceil(properties.length / resultsPerPage);

//     if (loading) return <p>Loading...</p>;

//     if (!user) {
//         navigate("/");
//         return null;
//     }

//     return (
//         <div id="layout-wrapper">
//             <Header User={user} />
//             <div className="main-content">
//                 <div className="page-content">
//                     <div className="container-fluid">
//                         <div className="card">
//                             <div className="card-body p-3">
//                                 <div className="row mb-3">
//                                     <div className="col-12">
//                                         <div className="d-flex align-items-center mb-3">
//                                             <div className="flex-grow-1">
//                                                 <h6 className="card-title text-primary mb-0">
//                                                     <i className="ri-building-line me-2"></i>
//                                                     Pending Approvals ({properties.length})
//                                                 </h6>
//                                                 <small className="text-muted">
//                                                     Review and approve draft properties to publish them
//                                                 </small>
//                                             </div>
//                                             <div className="d-flex gap-2">
//                                                 <div className="input-group input-group-sm" style={{ width: '280px' }}>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         placeholder="Search by hotel name, city, country..."
//                                                         value={searchTerm}
//                                                         onChange={(e) => setSearchTerm(e.target.value)}
//                                                         onKeyPress={handleSearchKeyPress}
//                                                     />
//                                                     <button
//                                                         className="btn btn-primary"
//                                                         type="button"
//                                                         onClick={handleSearch}
//                                                         disabled={isSearching}
//                                                     >
//                                                         <i className="ri-search-line me-1"></i>
//                                                         {isSearching ? "Searching..." : "Search"}
//                                                     </button>
//                                                 </div>
//                                                 <button
//                                                     className="btn btn-outline-primary btn-sm"
//                                                     onClick={fetchProperties}
//                                                     disabled={isLoading}
//                                                 >
//                                                     <i className="ri-refresh-line me-2"></i>
//                                                     {isLoading ? "Refreshing..." : "Refresh"}
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         {isLoading && (
//                                             <div className="text-center py-4">
//                                                 <div className="spinner-border text-primary spinner-border-sm" role="status">
//                                                     <span className="visually-hidden">Loading...</span>
//                                                 </div>
//                                                 <p className="mt-2 small">Loading pending approvals...</p>
//                                             </div>
//                                         )}

//                                         {error && !isLoading && (
//                                             <div className="alert alert-danger text-center py-3">
//                                                 <i className="ri-error-warning-line mb-2 text-danger" style={{ fontSize: '32px' }}></i>
//                                                 <h6 className="mb-2">Error Loading Properties</h6>
//                                                 <p className="small text-muted mb-2">{error}</p>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-outline-primary btn-sm"
//                                                     onClick={fetchProperties}
//                                                 >
//                                                     Try Again
//                                                 </button>
//                                             </div>
//                                         )}

//                                         {!isLoading && !error && properties.length === 0 && (
//                                             <div className="text-center py-4">
//                                                 <i className="ri-check-double-line mb-2 text-success" style={{ fontSize: '48px' }}></i>
//                                                 <h6 className="mb-2 text-success">No Pending Approvals</h6>
//                                                 <p className="small text-muted mb-3">
//                                                     {searchTerm ? `No pending approvals found for "${searchTerm}"` : "All properties have been reviewed and approved."}
//                                                 </p>
//                                                 {searchTerm && (
//                                                     <button
//                                                         className="btn btn-outline-primary btn-sm"
//                                                         onClick={() => {
//                                                             setSearchTerm("");
//                                                             fetchProperties();
//                                                         }}
//                                                     >
//                                                         Clear Search
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         )}

//                                         {!isLoading && !error && properties.length > 0 && (
//                                             <>
//                                                 <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
//                                                     <div>
//                                                         <small className="fw-bold">
//                                                             {properties.length} Pending Properties
//                                                         </small>
//                                                         <small className="text-muted d-block">
//                                                             Showing {currentResults.length} of {properties.length}
//                                                         </small>
//                                                     </div>
//                                                     <div>
//                                                         <small className="text-muted">
//                                                             Page {currentPage}/{totalPages}
//                                                         </small>
//                                                     </div>
//                                                 </div>

//                                                 <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 mb-3">
//                                                     {currentResults.map((property, index) => {
//                                                         const lowestPrice = getLowestRoomPrice(property.roomDetails);
//                                                         const validityDates = getValidityDates(property.roomDetails);
//                                                         const propertyId = property.hotelId || property.companyHotelId;
//                                                         const companyId = property.companyId;
                                                        
//                                                         return (
//                                                             <div key={propertyId || index} className="col">
//                                                                 <div 
//                                                                     className="card h-100 product-card"
//                                                                     style={{
//                                                                         cursor: 'pointer',
//                                                                         transition: 'all 0.3s ease',
//                                                                         boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                                                                         borderRadius: '12px',
//                                                                         overflow: 'hidden'
//                                                                     }}
//                                                                     onClick={() => openDetailsModal(property)}
//                                                                 >
//                                                                     <div className="position-relative">
//                                                                         {property.hotelImage ? (
//                                                                             <img
//                                                                                 src={property.hotelImage}
//                                                                                 className="card-img-top"
//                                                                                 alt={property.hotelName}
//                                                                                 style={{ height: '200px', objectFit: 'cover', width: '100%' }}
//                                                                                 onError={(e) => {
//                                                                                     e.target.onerror = null;
//                                                                                     e.target.src = `https://via.placeholder.com/300x200/667eea/ffffff?text=${encodeURIComponent(property.hotelName?.substring(0, 20) || 'Property')}`;
//                                                                                 }}
//                                                                             />
//                                                                         ) : (
//                                                                             <div className="card-img-top bg-gradient-primary d-flex align-items-center justify-content-center"
//                                                                                  style={{ height: '200px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//                                                                                 <i className="ri-building-line text-white" style={{ fontSize: '48px' }}></i>
//                                                                             </div>
//                                                                         )}
//                                                                         <div className="position-absolute top-0 start-0 p-2">
//                                                                             <span className="badge bg-warning">
//                                                                                 <i className="ri-time-line me-1"></i>
//                                                                                 Pending Approval
//                                                                             </span>
//                                                                         </div>
//                                                                         <div className="position-absolute top-0 end-0 p-2">
//                                                                             {property.contactInfo?.companyName && (
//                                                                                 <span className="badge bg-secondary">
//                                                                                     <i className="ri-flag-line me-1"></i>
//                                                                                     {property.contactInfo?.companyName}
//                                                                                 </span>
//                                                                             )}
//                                                                         </div>
//                                                                     </div>

//                                                                     <div className="card-body">
//                                                                         <div className="d-flex justify-content-between align-items-start mb-2">
//                                                                             <h6 className="card-title text-truncate mb-0 me-1">{property.hotelName}</h6>
//                                                                             <div className="d-flex align-items-center flex-shrink-0">
//                                                                                 {renderStars(property.starRating || 0)}
//                                                                                 <span className="ms-1 fw-bold text-warning" style={{ fontSize: '12px' }}>
//                                                                                     {property.starRating || 'N/A'}
//                                                                                 </span>
//                                                                             </div>
//                                                                         </div>
                                                                        
//                                                                         <div className="d-flex align-items-center text-muted small mb-2">
//                                                                             <i className="ri-map-pin-line me-1 flex-shrink-0"></i>
//                                                                             <span className="text-truncate">
//                                                                                 {[property.city, property.country].filter(Boolean).join(', ')}
//                                                                             </span>
//                                                                         </div>

//                                                                         {lowestPrice && (
//                                                                             <div className="mb-2 p-2 bg-success bg-opacity-10 rounded">
//                                                                                 <small className="text-success d-flex align-items-center">
//                                                                                     <i className="ri-tag-fill me-1"></i>
//                                                                                     <span className="fw-bold">From:</span>
//                                                                                     <span className="ms-1 fw-bold">
//                                                                                         {getCurrencySymbol(lowestPrice.currency)}{lowestPrice.price}
//                                                                                     </span>
//                                                                                 </small>
//                                                                             </div>
//                                                                         )}

//                                                                         {validityDates && (validityDates.from || validityDates.to) && (
//                                                                             <div className="mb-2 p-1 bg-light rounded">
//                                                                                 <div className="d-flex align-items-center text-muted small">
//                                                                                     <i className="ri-calendar-check-line me-1 text-primary"></i>
//                                                                                     <div style={{ fontSize: '10px' }}>
//                                                                                         {validityDates.from && (
//                                                                                             <span className="me-1">
//                                                                                                 <span className="fw-bold">From:</span> {validityDates.from}
//                                                                                             </span>
//                                                                                         )}
//                                                                                         {validityDates.to && (
//                                                                                             <span>
//                                                                                                 <span className="fw-bold ms-1">To:</span> {validityDates.to}
//                                                                                             </span>
//                                                                                         )}
//                                                                                     </div>
//                                                                                 </div>
//                                                                             </div>
//                                                                         )}

//                                                                         {property.roomDetails?.length > 0 && (
//                                                                             <div className="mb-1">
//                                                                                 <small className="text-success d-flex align-items-center">
//                                                                                     <i className="ri-checkbox-circle-fill me-1"></i>
//                                                                                     <span>{property.roomDetails.length} room type(s)</span>
//                                                                                 </small>
//                                                                             </div>
//                                                                         )}
//                                                                     </div>

//                                                                     <div className="card-footer bg-transparent border-top pt-2 pb-2">
//                                                                         <div className="d-flex justify-content-between align-items-center">
//                                                                             <button
//                                                                                 className="btn btn-sm btn-primary"
//                                                                                 onClick={(e) => {
//                                                                                     e.stopPropagation();
//                                                                                     openDetailsModal(property);
//                                                                                 }}
//                                                                                 title="View Details"
//                                                                             >
//                                                                                 <i className="ri-eye-line me-1"></i>
//                                                                                 Details
//                                                                             </button>
//                                                                             <button
//                                                                                 className="btn btn-sm btn-success"
//                                                                                 onClick={(e) => handleApproveProperty(propertyId, companyId, e)}
//                                                                                 disabled={approvingId === propertyId}
//                                                                                 title="Approve and Publish"
//                                                                             >
//                                                                                 {approvingId === propertyId ? (
//                                                                                     <>
//                                                                                         <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
//                                                                                         Approving...
//                                                                                     </>
//                                                                                 ) : (
//                                                                                     <>
//                                                                                         <i className="ri-check-double-line me-1"></i>
//                                                                                         Approve
//                                                                                     </>
//                                                                                 )}
//                                                                             </button>
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     })}
//                                                 </div>

//                                                 {totalPages > 1 && (
//                                                     <nav aria-label="Properties pagination" className="mt-3">
//                                                         <ul className="pagination pagination-sm justify-content-center flex-wrap mb-0">
//                                                             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(1)}
//                                                                     disabled={currentPage === 1}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     First
//                                                                 </button>
//                                                             </li>
//                                                             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                                                                     disabled={currentPage === 1}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     Prev
//                                                                 </button>
//                                                             </li>
//                                                             {Array.from({ length: Math.min(3, totalPages) }, (_, i) => {
//                                                                 let pageNum;
//                                                                 if (totalPages <= 3) {
//                                                                     pageNum = i + 1;
//                                                                 } else if (currentPage <= 2) {
//                                                                     pageNum = i + 1;
//                                                                 } else if (currentPage >= totalPages - 1) {
//                                                                     pageNum = totalPages - 2 + i;
//                                                                 } else {
//                                                                     pageNum = currentPage - 1 + i;
//                                                                 }
//                                                                 return (
//                                                                     <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
//                                                                         <button
//                                                                             className="page-link"
//                                                                             onClick={() => setCurrentPage(pageNum)}
//                                                                             style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                         >
//                                                                             {pageNum}
//                                                                         </button>
//                                                                     </li>
//                                                                 );
//                                                             })}
//                                                             <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                                                                     disabled={currentPage === totalPages}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     Next
//                                                                 </button>
//                                                             </li>
//                                                             <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(totalPages)}
//                                                                     disabled={currentPage === totalPages}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     Last
//                                                                 </button>
//                                                             </li>
//                                                         </ul>
//                                                     </nav>
//                                                 )}
//                                             </>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Property Details Modal with Approve Button */}
//             {showDetailsModal && selectedPropertyDetails && (
//                 <div className="modal-overlay" style={styles.modalOverlay}>
//                     <div className="modal-container" style={styles.modalContainer}>
//                         <div className="modal-header" style={styles.modalHeader}>
//                             <h5 className="modal-title text-white">
//                                 <i className="ri-building-line me-2"></i>
//                                 {selectedPropertyDetails.hotelName}
//                             </h5>
//                             <button
//                                 type="button"
//                                 className="btn-close btn-close-white"
//                                 onClick={closeDetailsModal}
//                             ></button>
//                         </div>

//                         <div className="modal-body" style={styles.modalBody}>
//                             <div className="row g-4">
//                                 <div className="col-md-5">
//                                     {selectedPropertyDetails.hotelImage ? (
//                                         <img
//                                             src={selectedPropertyDetails.hotelImage}
//                                             className="img-fluid rounded shadow"
//                                             alt={selectedPropertyDetails.hotelName}
//                                             style={{ width: '100%', height: '300px', objectFit: 'cover' }}
//                                             onError={(e) => {
//                                                 e.target.onerror = null;
//                                                 e.target.src = `https://via.placeholder.com/600x400/667eea/ffffff?text=${encodeURIComponent(selectedPropertyDetails.hotelName?.substring(0, 20) || 'Property')}`;
//                                             }}
//                                         />
//                                     ) : (
//                                         <div className="bg-gradient-primary rounded shadow d-flex align-items-center justify-content-center"
//                                              style={{ height: '300px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//                                             <i className="ri-building-line text-white" style={{ fontSize: '64px' }}></i>
//                                         </div>
//                                     )}

//                                     <div className="mt-3">
//                                         <div className="card border-warning mb-3">
//                                             <div className="card-body text-center">
//                                                 <h6 className="card-title text-warning mb-2">Star Rating</h6>
//                                                 <div className="d-flex justify-content-center align-items-center">
//                                                     {renderStars(selectedPropertyDetails.starRating || 0)}
//                                                     <span className="ms-2 fw-bold fs-5">
//                                                         {selectedPropertyDetails.starRating || 'N/A'} Star
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         </div>
                                        
//                                         <div className="card border-primary mb-3">
//                                             <div className="card-body text-center">
//                                                 <h6 className="card-title text-primary mb-2">Property Type</h6>
//                                                 <h4 className="text-primary mb-0">
//                                                     {selectedPropertyDetails.accommodationType || 'Hotel'}
//                                                 </h4>
//                                             </div>
//                                         </div>

//                                         <div className="card border-warning mb-3">
//                                             <div className="card-body text-center">
//                                                 <h6 className="card-title text-warning mb-2">Status</h6>
//                                                 <span className="badge bg-warning fs-6">
//                                                     <i className="ri-time-line me-1"></i>
//                                                     Pending Approval
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-md-7">
//                                     <div className="card border-success mb-3">
//                                         <div className="card-header bg-success bg-opacity-10">
//                                             <h6 className="mb-0 text-success">Location Details</h6>
//                                         </div>
//                                         <div className="card-body">
//                                             <div className="row">
//                                                 <div className="col-md-6 mb-2">
//                                                     <strong>Address:</strong>
//                                                     <p className="mb-1">{selectedPropertyDetails.address || 'Not Available'}</p>
//                                                 </div>
//                                                 <div className="col-md-3 mb-2">
//                                                     <strong>City:</strong>
//                                                     <p className="mb-1">{selectedPropertyDetails.city || 'N/A'}</p>
//                                                 </div>
//                                                 <div className="col-md-3 mb-2">
//                                                     <strong>State:</strong>
//                                                     <p className="mb-1">{selectedPropertyDetails.state || 'N/A'}</p>
//                                                 </div>
//                                                 <div className="col-md-4 mb-2">
//                                                     <strong>Country:</strong>
//                                                     <p className="mb-1">{selectedPropertyDetails.country || 'N/A'}</p>
//                                                 </div>
//                                                 <div className="col-md-4 mb-2">
//                                                     <strong>Postal Code:</strong>
//                                                     <p className="mb-1">{selectedPropertyDetails.postalCode || 'N/A'}</p>
//                                                 </div>
//                                                 <div className="col-md-4 mb-2">
//                                                     <strong>Country Code:</strong>
//                                                     <p className="mb-1">{selectedPropertyDetails.countryCode || 'N/A'}</p>
//                                                 </div>
//                                                 {selectedPropertyDetails.latitude && selectedPropertyDetails.longitude && (
//                                                     <div className="col-12">
//                                                         <a
//                                                             href={`https://www.google.com/maps?q=${selectedPropertyDetails.latitude},${selectedPropertyDetails.longitude}`}
//                                                             target="_blank"
//                                                             rel="noopener noreferrer"
//                                                             className="btn btn-sm btn-primary"
//                                                         >
//                                                             <i className="ri-map-pin-line me-1"></i>
//                                                             View on Google Maps
//                                                         </a>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {selectedPropertyDetails.contactInfo && (
//                                         <div className="card border-info mb-3">
//                                             <div className="card-header bg-info bg-opacity-10">
//                                                 <h6 className="mb-0 text-info">Contact Details</h6>
//                                             </div>
//                                             <div className="card-body">
//                                                 <div className="row">
//                                                     <div className="col-md-6 mb-2">
//                                                         <strong>Contact Name:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.contactInfo.contactName || 'Not Available'}</p>
//                                                     </div>
//                                                     <div className="col-md-6 mb-2">
//                                                         <strong>Email:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.contactInfo.email || 'Not Available'}</p>
//                                                     </div>
//                                                     <div className="col-md-6 mb-2">
//                                                         <strong>Phone:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.contactInfo.phone || 'Not Available'}</p>
//                                                     </div>
//                                                     <div className="col-md-6 mb-2">
//                                                         <strong>WhatsApp:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.contactInfo.whatsApp || 'Not Available'}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {selectedPropertyDetails.roomDetails && selectedPropertyDetails.roomDetails.length > 0 && (
//                                         <div className="card border-primary mb-3">
//                                             <div className="card-header bg-primary bg-opacity-10">
//                                                 <div className="d-flex justify-content-between align-items-center">
//                                                     <h6 className="mb-0 text-primary">Available Room Types</h6>
//                                                     <span className="badge bg-primary">
//                                                         Valid: {getValidityPeriod(selectedPropertyDetails.roomDetails)}
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                             <div className="card-body">
//                                                 <div className="table-responsive">
//                                                     <table className="table table-hover">
//                                                         <thead className="table-light">
//                                                             <tr>
//                                                                 <th>Room Type</th>
//                                                                 <th>Meal Plan</th>
//                                                                 <th>Price</th>
//                                                                 <th>Extra Bed</th>
//                                                                 <th>Child w/o Bed</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {selectedPropertyDetails.roomDetails.map((room, index) => (
//                                                                 <tr key={index}>
//                                                                     <td>{room.roomType}</td>
//                                                                     <td>{getMealPlanLabel(room.mealPlan)}</td>
//                                                                     <td>
//                                                                         <strong className="text-success">
//                                                                             {formatCurrency(room.price, room.currency)}
//                                                                         </strong>
//                                                                     </td>
//                                                                     <td>
//                                                                         {room.extraBedPrice ? (
//                                                                             <span className="badge bg-success">
//                                                                                 {formatCurrency(room.extraBedPrice, room.currency)}
//                                                                             </span>
//                                                                         ) : (
//                                                                             <span className="badge bg-secondary">N/A</span>
//                                                                         )}
//                                                                     </td>
//                                                                     <td>
//                                                                         {room.childWithoutBedPrice ? (
//                                                                             <span className="badge bg-info">
//                                                                                 {formatCurrency(room.childWithoutBedPrice, room.currency)}
//                                                                             </span>
//                                                                         ) : (
//                                                                             <span className="badge bg-secondary">N/A</span>
//                                                                         )}
//                                                                     </td>
//                                                                 </tr>
//                                                             ))}
//                                                         </tbody>
//                                                     </table>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {selectedPropertyDetails.amenities && selectedPropertyDetails.amenities.length > 0 && (
//                                         <div className="card border-success mb-3">
//                                             <div className="card-header bg-success bg-opacity-10">
//                                                 <h6 className="mb-0 text-success">Amenities & Facilities</h6>
//                                             </div>
//                                             <div className="card-body">
//                                                 <div className="row">
//                                                     {selectedPropertyDetails.amenities.map((amenity, index) => (
//                                                         <div key={index} className="col-md-6 mb-2">
//                                                             <i className="ri-checkbox-circle-fill text-success me-2"></i>
//                                                             {amenity.point}
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <div className="row">
//                                         {selectedPropertyDetails.termsAndConditions && selectedPropertyDetails.termsAndConditions.length > 0 && (
//                                             <div className="col-md-6 mb-3">
//                                                 <div className="card border-warning h-100">
//                                                     <div className="card-header bg-warning bg-opacity-10">
//                                                         <h6 className="mb-0 text-warning">Terms & Conditions</h6>
//                                                     </div>
//                                                     <div className="card-body">
//                                                         <ul className="list-group list-group-flush">
//                                                             {selectedPropertyDetails.termsAndConditions.slice(0, 5).map((term, index) => (
//                                                                 <li key={index} className="list-group-item px-0">
//                                                                     <i className="ri-dot-text text-warning me-2"></i>
//                                                                     {term.point}
//                                                                 </li>
//                                                             ))}
//                                                         </ul>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
                                        
//                                         {selectedPropertyDetails.cancellationPolicy && selectedPropertyDetails.cancellationPolicy.length > 0 && (
//                                             <div className="col-md-6 mb-3">
//                                                 <div className="card border-danger h-100">
//                                                     <div className="card-header bg-danger bg-opacity-10">
//                                                         <h6 className="mb-0 text-danger">Cancellation Policy</h6>
//                                                     </div>
//                                                     <div className="card-body">
//                                                         <ul className="list-group list-group-flush">
//                                                             {selectedPropertyDetails.cancellationPolicy.slice(0, 5).map((policy, index) => (
//                                                                 <li key={index} className="list-group-item px-0">
//                                                                     <i className="ri-dot-text text-danger me-2"></i>
//                                                                     {policy.point}
//                                                                 </li>
//                                                             ))}
//                                                         </ul>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="modal-footer" style={styles.modalFooter}>
//                             <div className="d-flex gap-2 flex-wrap">
//                                 <button
//                                     type="button"
//                                     className="btn btn-success"
//                                     onClick={() => {
//                                         const propertyId = selectedPropertyDetails.hotelId || selectedPropertyDetails.companyHotelId;
//                                         const companyId = selectedPropertyDetails.companyId;
//                                         handleApproveProperty(propertyId, companyId);
//                                     }}
//                                     disabled={approvingId === (selectedPropertyDetails.hotelId || selectedPropertyDetails.companyHotelId)}
//                                 >
//                                     {approvingId === (selectedPropertyDetails.hotelId || selectedPropertyDetails.companyHotelId) ? (
//                                         <>
//                                             <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
//                                             Approving...
//                                         </>
//                                     ) : (
//                                         <>
//                                             <i className="ri-check-double-line me-1"></i>
//                                             Approve & Publish
//                                         </>
//                                     )}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="btn btn-danger"
//                                     onClick={closeDetailsModal}
//                                 >
//                                     <i className="ri-close-line me-1"></i>
//                                     Close
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <style jsx>{`
//                 .product-card:hover {
//                     border-color: #0d6efd !important;
//                     transform: translateY(-5px) !important;
//                     box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
//                 }
                
//                 .bg-gradient-primary {
//                     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//                 }
                
//                 @keyframes slideIn {
//                     from {
//                         transform: translateY(-50px);
//                         opacity: 0;
//                     }
//                     to {
//                         transform: translateY(0);
//                         opacity: 1;
//                     }
//                 }
                
//                 @media (max-width: 768px) {
//                     .modal-container {
//                         margin: 10px;
//                         max-height: 95vh;
//                     }
                    
//                     .modal-body {
//                         padding: 15px;
//                     }
                    
//                     .input-group {
//                         width: 180px !important;
//                     }
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default PropertiesApproval;




import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { useNavigate } from "react-router-dom";

// Styles for both components
const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        backdropFilter: 'blur(5px)',
    },
    modalContainer: {
        backgroundColor: 'white',
        borderRadius: '15px',
        width: '100%',
        maxWidth: '1400px',
        maxHeight: '90vh',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        animation: 'slideIn 0.3s ease-out',
    },
    modalHeader: {
        backgroundColor: '#667eea',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '20px 30px',
        borderBottom: 'none',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    modalBody: {
        padding: '30px',
        overflowY: 'auto',
        maxHeight: 'calc(90vh - 150px)',
    },
    modalFooter: {
        padding: '15px 30px',
        borderTop: '1px solid #dee2e6',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px',
    },
};

const PropertiesApproval = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    
    // State for properties
    const [properties, setProperties] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const [approvingId, setApprovingId] = useState(null);
    
    // Property details modal
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedPropertyDetails, setSelectedPropertyDetails] = useState(null);
    
    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [resultsPerPage] = useState(12);

    const currencyOptions = [
        { code: "INR", symbol: "₹", name: "Indian Rupee" },
        { code: "USD", symbol: "$", name: "US Dollar" },
        { code: "EUR", symbol: "€", name: "Euro" },
        { code: "GBP", symbol: "£", name: "British Pound" },
        { code: "AED", symbol: "AED", name: "UAE Dirham" },
        { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
        { code: "AUD", symbol: "A$", name: "Australian Dollar" },
        { code: "CAD", symbol: "C$", name: "Canadian Dollar" }
    ];

    // Fetch properties on component mount
    useEffect(() => {
        if (user && !loading) {
            fetchProperties();
        }
    }, [user, loading]);

    // API call to get all Draft properties
    const fetchProperties = async () => {
        setIsLoading(true);
        setError(null);
        
        try {
            // Fetch all properties
            const response = await apiService.getAll(
                `${config.GETAllCOMPANYHOTELS}`
            );
            
            const fetchedProperties = response.hotels || response.data || [];
            
            // Filter to only show draft/pending properties
            // Adjust this based on your actual data structure
            const draftProperties = fetchedProperties.filter(p => 
                p.isActive !== "Published" && 
                p.isActive !== true &&
                p.status !== "Published" &&
                p.status !== "Approved"
            );
            
            setProperties(draftProperties);
            setCurrentPage(1);
        } catch (error) {
            console.error("Error fetching properties:", error);
            setError("Failed to load properties. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    // Handle search
    const handleSearch = async () => {
        if (!searchTerm.trim()) {
            await fetchProperties();
            return;
        }
        
        setIsSearching(true);
        setError(null);
        
        try {
            const response = await apiService.getAll(
                `${config.GETAllCOMPANYHOTELS}?search=${encodeURIComponent(searchTerm)}`
            );
            
            const fetchedProperties = response.hotels || response.data || [];
            
            // Filter search results to only show drafts
            const draftProperties = fetchedProperties.filter(p => 
                p.isActive !== "Published" && 
                p.isActive !== true &&
                p.status !== "Published" &&
                p.status !== "Approved"
            );
            
            setProperties(draftProperties);
            setCurrentPage(1);
        } catch (error) {
            console.error("Error searching properties:", error);
            setError("Failed to search properties. Please try again.");
        } finally {
            setIsSearching(false);
        }
    };

    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    // Approve property - Update status from Draft to Published
    const handleApproveProperty = async (hotelId, companyId, e) => {
        if (e) e.stopPropagation();
        
        if (!hotelId || !companyId) {
            alert("Missing required information to approve this property.");
            return;
        }

        if (!window.confirm("Are you sure you want to approve this property? It will be published and visible to all users.")) {
            return;
        }

        setApprovingId(hotelId);

        try {
            const requestData = {
                CompanyId: companyId,
                HotelId: hotelId,
                IsActive: "Published"
            };

            const response = await apiService.put(
                `${config.UPDATECOMPANYHOTELSTATUS}`,
                requestData
            );

            if (response.success || response.data) {
                alert("Property approved and published successfully!");
                
                // Remove the approved property from the list
                setProperties(prev => prev.filter(p => {
                    const propId = p.hotelId || p.companyHotelId;
                    return propId !== hotelId;
                }));
                
                // If details modal is open, close it if it's showing this property
                if (showDetailsModal && selectedPropertyDetails) {
                    const isCurrentProperty = 
                        selectedPropertyDetails.hotelId === hotelId || 
                        selectedPropertyDetails.companyHotelId === hotelId;
                    if (isCurrentProperty) {
                        closeDetailsModal();
                    }
                }
            } else {
                throw new Error(response.message || "Failed to approve property");
            }
        } catch (error) {
            console.error("Error approving property:", error);
            alert(error.message || "Failed to approve property. Please try again.");
        } finally {
            setApprovingId(null);
        }
    };

    // Get lowest room price for a property
    const getLowestRoomPrice = (roomDetails) => {
        if (!roomDetails || roomDetails.length === 0) {
            return null;
        }
        
        const validRooms = roomDetails.filter(room => room.price && !isNaN(room.price));
        if (validRooms.length === 0) return null;
        
        const lowest = validRooms.reduce((min, room) => 
            room.price < min.price ? room : min
        , validRooms[0]);
        
        return {
            price: lowest.price,
            currency: lowest.currency,
            roomType: lowest.roomType
        };
    };

    // Get validity dates with better formatting
    const getValidityDates = (roomDetails) => {
        if (!roomDetails || roomDetails.length === 0) return null;
        
        let validFrom = null;
        let validTo = null;
        
        roomDetails.forEach(room => {
            if (room.validFrom && room.validFrom !== 'Not specified') {
                const fromDate = new Date(room.validFrom);
                if (!validFrom || fromDate < validFrom) validFrom = fromDate;
            }
            if (room.validTo && room.validTo !== 'Not specified') {
                const toDate = new Date(room.validTo);
                if (!validTo || toDate > validTo) validTo = toDate;
            }
        });
        
        return {
            from: validFrom ? formatDate(validFrom) : null,
            to: validTo ? formatDate(validTo) : null,
            isActive: validFrom && validTo ? new Date() >= validFrom && new Date() <= validTo : false
        };
    };

    // Open property details modal
    const openDetailsModal = (property) => {
        setSelectedPropertyDetails(property);
        setShowDetailsModal(true);
    };

    // Close property details modal
    const closeDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedPropertyDetails(null);
    };

    // Render star rating
    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating || 0);
        const hasHalfStar = (rating || 0) % 1 >= 0.5;

        for (let i = 1; i <= 5; i++) {
            if (i <= fullStars) {
                stars.push(<i key={i} className="ri-star-fill text-warning"></i>);
            } else if (i === fullStars + 1 && hasHalfStar) {
                stars.push(<i key={i} className="ri-star-half-fill text-warning"></i>);
            } else {
                stars.push(<i key={i} className="ri-star-line text-warning"></i>);
            }
        }
        return <span className="d-inline-flex align-items-center">{stars}</span>;
    };

    // Format currency
    const formatCurrency = (amount, currency) => {
        const symbols = {
            'INR': '₹',
            'USD': '$',
            'EUR': '€',
            'GBP': '£',
            'AED': 'AED ',
            'SGD': 'S$',
            'AUD': 'A$',
            'CAD': 'C$'
        };
        const symbol = symbols[currency] || currency;
        return `${symbol}${amount}`;
    };

    const getCurrencySymbol = (currencyCode) => {
        const currency = currencyOptions.find(c => c.code === currencyCode);
        return currency ? currency.symbol : currencyCode;
    };

    // Get meal plan label
    const getMealPlanLabel = (mealPlan) => {
        const plans = {
            'CP': 'CP → Breakfast only',
            'MAP': 'MAP → Breakfast + Lunch or Dinner',
            'AP': 'AP → Breakfast + Lunch + Dinner',
            'EP': 'EP → Room only',
            'CPAI': 'CPAI → Stay + Breakfast',
            'MAPAI': 'MAPAI → Stay + Breakfast + Lunch/Dinner',
            'APAI': 'APAI → Stay + Breakfast + Lunch + Dinner'
        };
        return plans[mealPlan] || mealPlan;
    };

    // Format date to display
    const formatDate = (dateString) => {
        if (!dateString || dateString === 'Not specified') return 'N/A';
        
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    };

    // Get validity period for room details
    const getValidityPeriod = (roomDetails) => {
        if (!roomDetails || roomDetails.length === 0) return 'N/A';
        
        let earliestDate = null;
        let latestDate = null;
        
        roomDetails.forEach(room => {
            if (room.validFrom && room.validFrom !== 'Not specified') {
                const fromDate = new Date(room.validFrom);
                if (!earliestDate || fromDate < earliestDate) {
                    earliestDate = fromDate;
                }
            }
            
            if (room.validTo && room.validTo !== 'Not specified') {
                const toDate = new Date(room.validTo);
                if (!latestDate || toDate > latestDate) {
                    latestDate = toDate;
                }
            }
        });
        
        if (earliestDate && latestDate) {
            return `${formatDate(earliestDate)} to ${formatDate(latestDate)}`;
        } else if (earliestDate) {
            return `From ${formatDate(earliestDate)}`;
        } else if (latestDate) {
            return `Until ${formatDate(latestDate)}`;
        }
        
        return 'N/A';
    };

    // Pagination
    const indexOfLastResult = currentPage * resultsPerPage;
    const indexOfFirstResult = indexOfLastResult - resultsPerPage;
    const currentResults = properties.slice(indexOfFirstResult, indexOfLastResult);
    const totalPages = Math.ceil(properties.length / resultsPerPage);

    if (loading) return <p>Loading...</p>;

    if (!user) {
        navigate("/");
        return null;
    }

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-body p-3">
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="flex-grow-1">
                                                <h6 className="card-title text-primary mb-0">
                                                    <i className="ri-building-line me-2"></i>
                                                    Pending Approvals ({properties.length})
                                                </h6>
                                                <small className="text-muted">
                                                    Review and approve draft properties to publish them
                                                </small>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <div className="input-group input-group-sm" style={{ width: '280px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by hotel name, city, country..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        onKeyPress={handleSearchKeyPress}
                                                    />
                                                    <button
                                                        className="btn btn-primary"
                                                        type="button"
                                                        onClick={handleSearch}
                                                        disabled={isSearching}
                                                    >
                                                        <i className="ri-search-line me-1"></i>
                                                        {isSearching ? "Searching..." : "Search"}
                                                    </button>
                                                </div>
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={fetchProperties}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-refresh-line me-2"></i>
                                                    {isLoading ? "Refreshing..." : "Refresh"}
                                                </button>
                                            </div>
                                        </div>

                                        {isLoading && (
                                            <div className="text-center py-4">
                                                <div className="spinner-border text-primary spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-2 small">Loading pending approvals...</p>
                                            </div>
                                        )}

                                        {error && !isLoading && (
                                            <div className="alert alert-danger text-center py-3">
                                                <i className="ri-error-warning-line mb-2 text-danger" style={{ fontSize: '32px' }}></i>
                                                <h6 className="mb-2">Error Loading Properties</h6>
                                                <p className="small text-muted mb-2">{error}</p>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={fetchProperties}
                                                >
                                                    Try Again
                                                </button>
                                            </div>
                                        )}

                                        {!isLoading && !error && properties.length === 0 && (
                                            <div className="text-center py-4">
                                                <i className="ri-check-double-line mb-2 text-success" style={{ fontSize: '48px' }}></i>
                                                <h6 className="mb-2 text-success">No Pending Approvals</h6>
                                                <p className="small text-muted mb-3">
                                                    {searchTerm ? `No pending approvals found for "${searchTerm}"` : "All properties have been reviewed and approved."}
                                                </p>
                                                {searchTerm && (
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => {
                                                            setSearchTerm("");
                                                            fetchProperties();
                                                        }}
                                                    >
                                                        Clear Search
                                                    </button>
                                                )}
                                            </div>
                                        )}

                                        {!isLoading && !error && properties.length > 0 && (
                                            <>
                                                <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
                                                    <div>
                                                        <small className="fw-bold">
                                                            {properties.length} Pending Properties
                                                        </small>
                                                        <small className="text-muted d-block">
                                                            Showing {currentResults.length} of {properties.length}
                                                        </small>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">
                                                            Page {currentPage}/{totalPages}
                                                        </small>
                                                    </div>
                                                </div>

                                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 mb-3">
                                                    {currentResults.map((property, index) => {
                                                        const lowestPrice = getLowestRoomPrice(property.roomDetails);
                                                        const validityDates = getValidityDates(property.roomDetails);
                                                        const propertyId = property.hotelId || property.companyHotelId;
                                                        const companyId = property.companyId;
                                                        
                                                        return (
                                                            <div key={propertyId || index} className="col">
                                                                <div 
                                                                    className="card h-100 product-card"
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                                        borderRadius: '12px',
                                                                        overflow: 'hidden'
                                                                    }}
                                                                    onClick={() => openDetailsModal(property)}
                                                                >
                                                                    <div className="position-relative">
                                                                        {property.hotelImage ? (
                                                                            <img
                                                                                src={property.hotelImage}
                                                                                className="card-img-top"
                                                                                alt={property.hotelName}
                                                                                style={{ height: '200px', objectFit: 'cover', width: '100%' }}
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = `https://via.placeholder.com/300x200/667eea/ffffff?text=${encodeURIComponent(property.hotelName?.substring(0, 20) || 'Property')}`;
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <div className="card-img-top bg-gradient-primary d-flex align-items-center justify-content-center"
                                                                                 style={{ height: '200px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                                                                <i className="ri-building-line text-white" style={{ fontSize: '48px' }}></i>
                                                                            </div>
                                                                        )}
                                                                        <div className="position-absolute top-0 start-0 p-2">
                                                                            <span className="badge bg-warning">
                                                                                <i className="ri-time-line me-1"></i>
                                                                                Pending Approval
                                                                            </span>
                                                                        </div>
                                                                        <div className="position-absolute top-0 end-0 p-2">
                                                                            {property.contactInfo?.companyName && (
                                                                                <span className="badge bg-secondary">
                                                                                    <i className="ri-flag-line me-1"></i>
                                                                                    {property.contactInfo?.companyName}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                                                            <h6 className="card-title text-truncate mb-0 me-1">{property.hotelName}</h6>
                                                                            <div className="d-flex align-items-center flex-shrink-0">
                                                                                {renderStars(property.starRating || 0)}
                                                                                <span className="ms-1 fw-bold text-warning" style={{ fontSize: '12px' }}>
                                                                                    {property.starRating || 'N/A'}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div className="d-flex align-items-center text-muted small mb-2">
                                                                            <i className="ri-map-pin-line me-1 flex-shrink-0"></i>
                                                                            <span className="text-truncate">
                                                                                {[property.city, property.country].filter(Boolean).join(', ')}
                                                                            </span>
                                                                        </div>

                                                                        {lowestPrice && (
                                                                            <div className="mb-2 p-2 bg-success bg-opacity-10 rounded">
                                                                                <small className="text-success d-flex align-items-center">
                                                                                    <i className="ri-tag-fill me-1"></i>
                                                                                    <span className="fw-bold">From:</span>
                                                                                    <span className="ms-1 fw-bold">
                                                                                        {getCurrencySymbol(lowestPrice.currency)}{lowestPrice.price}
                                                                                    </span>
                                                                                </small>
                                                                            </div>
                                                                        )}

                                                                        {validityDates && (validityDates.from || validityDates.to) && (
                                                                            <div className="mb-2 p-1 bg-light rounded">
                                                                                <div className="d-flex align-items-center text-muted small">
                                                                                    <i className="ri-calendar-check-line me-1 text-primary"></i>
                                                                                    <div style={{ fontSize: '10px' }}>
                                                                                        {validityDates.from && (
                                                                                            <span className="me-1">
                                                                                                <span className="fw-bold">From:</span> {validityDates.from}
                                                                                            </span>
                                                                                        )}
                                                                                        {validityDates.to && (
                                                                                            <span>
                                                                                                <span className="fw-bold ms-1">To:</span> {validityDates.to}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {property.roomDetails?.length > 0 && (
                                                                            <div className="mb-1">
                                                                                <small className="text-success d-flex align-items-center">
                                                                                    <i className="ri-checkbox-circle-fill me-1"></i>
                                                                                    <span>{property.roomDetails.length} room type(s)</span>
                                                                                </small>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    <div className="card-footer bg-transparent border-top pt-2 pb-2">
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <button
                                                                                className="btn btn-sm btn-primary"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    openDetailsModal(property);
                                                                                }}
                                                                                title="View Details"
                                                                            >
                                                                                <i className="ri-eye-line me-1"></i>
                                                                                Details
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-success"
                                                                                onClick={(e) => handleApproveProperty(propertyId, companyId, e)}
                                                                                disabled={approvingId === propertyId}
                                                                                title="Approve and Publish"
                                                                            >
                                                                                {approvingId === propertyId ? (
                                                                                    <>
                                                                                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                                                        Approving...
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <i className="ri-check-double-line me-1"></i>
                                                                                        Approve
                                                                                    </>
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                                {totalPages > 1 && (
                                                    <nav aria-label="Properties pagination" className="mt-3">
                                                        <ul className="pagination pagination-sm justify-content-center flex-wrap mb-0">
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(1)}
                                                                    disabled={currentPage === 1}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    First
                                                                </button>
                                                            </li>
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                                                    disabled={currentPage === 1}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    Prev
                                                                </button>
                                                            </li>
                                                            {Array.from({ length: Math.min(3, totalPages) }, (_, i) => {
                                                                let pageNum;
                                                                if (totalPages <= 3) {
                                                                    pageNum = i + 1;
                                                                } else if (currentPage <= 2) {
                                                                    pageNum = i + 1;
                                                                } else if (currentPage >= totalPages - 1) {
                                                                    pageNum = totalPages - 2 + i;
                                                                } else {
                                                                    pageNum = currentPage - 1 + i;
                                                                }
                                                                return (
                                                                    <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                                        <button
                                                                            className="page-link"
                                                                            onClick={() => setCurrentPage(pageNum)}
                                                                            style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                        >
                                                                            {pageNum}
                                                                        </button>
                                                                    </li>
                                                                );
                                                            })}
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                                                    disabled={currentPage === totalPages}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    Next
                                                                </button>
                                                            </li>
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(totalPages)}
                                                                    disabled={currentPage === totalPages}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    Last
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Property Details Modal with Approve Button */}
            {showDetailsModal && selectedPropertyDetails && (
                <div className="modal-overlay" style={styles.modalOverlay}>
                    <div className="modal-container" style={styles.modalContainer}>
                        <div className="modal-header" style={styles.modalHeader}>
                            <h5 className="modal-title text-white">
                                <i className="ri-building-line me-2"></i>
                                {selectedPropertyDetails.hotelName}
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                onClick={closeDetailsModal}
                            ></button>
                        </div>

                        <div className="modal-body" style={styles.modalBody}>
                            {/* ... rest of the modal content remains the same ... */}
                        </div>

                        <div className="modal-footer" style={styles.modalFooter}>
                            <div className="d-flex gap-2 flex-wrap">
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => {
                                        const propertyId = selectedPropertyDetails.hotelId || selectedPropertyDetails.companyHotelId;
                                        const companyId = selectedPropertyDetails.companyId;
                                        handleApproveProperty(propertyId, companyId);
                                    }}
                                    disabled={approvingId === (selectedPropertyDetails.hotelId || selectedPropertyDetails.companyHotelId)}
                                >
                                    {approvingId === (selectedPropertyDetails.hotelId || selectedPropertyDetails.companyHotelId) ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Approving...
                                        </>
                                    ) : (
                                        <>
                                            <i className="ri-check-double-line me-1"></i>
                                            Approve & Publish
                                        </>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={closeDetailsModal}
                                >
                                    <i className="ri-close-line me-1"></i>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .product-card:hover {
                    border-color: #0d6efd !important;
                    transform: translateY(-5px) !important;
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
                }
                
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }
                
                @keyframes slideIn {
                    from {
                        transform: translateY(-50px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
                
                @media (max-width: 768px) {
                    .modal-container {
                        margin: 10px;
                        max-height: 95vh;
                    }
                    
                    .modal-body {
                        padding: 15px;
                    }
                    
                    .input-group {
                        width: 180px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default PropertiesApproval;